import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles
} from '@material-ui/core'

import Context from '../../context'

import { getMovieSession, removeMovieSession } from '../../services/ClubeApi'

function MovieSession(props) {
  const classes = useStyles()

  const [moviesList, setMoviesList] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [itemList, setItemList] = useState(null)
  const [title, setTitle] = useState('Sessões')

  const { setAboutCurrentPage } = useContext(Context)

  const modalController = () => {
    setModalVisible(!modalVisible)
  }

  const getItemList = item => {
    setItemList(item)
    modalController()
  }

  const onDeleteItem = async idItem => {
    await removeMovieSession(idItem)
    modalController()
  }

  const movies = async idFilme => {
    setLoading(true)
    const response = await getMovieSession(idFilme)

    console.log('dale', response)

    setMoviesList(response[0].MoviesSessions)
    setLoading(false)
  }

  useEffect(() => {
    if (props.location.state !== undefined) {
      const { id } = props.location.state.message
      movies(id)
    }

    if (props.location.state !== undefined) {
      setAboutCurrentPage({
        title,
        buttons: [
          {
            title: 'Novo sessão',
            pathname: '/movieSessionForm',
            state: { message: props.location.state.message }
          },
          { title: 'Voltar', pathname: '/movies' }
        ],
        tabs: [
          { title: 'Filmes', pathname: '/movieForm' },
          { title: 'Sessões', pathname: '/sessions' }
        ]
      })

      return
    }

    setAboutCurrentPage({
      title,
      buttons: [
        { title: 'Novo sessão', pathname: '/movieSessionForm' },
        { title: 'Voltar', pathname: '/movies' }
      ],
      tabs: [
        { title: 'Filmes', pathname: '/movieForm' },
        { title: 'Sessões', pathname: '/sessions' }
      ]
    })
  }, [])

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div className={classes.actions} />
            </div>
            <input className={classes.search} placeholder="Buscar..." />
          </div>

          <table className={classes.table}>
            <colgroup>
              <col />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
            </colgroup>
            <thead>
              <tr>
                <td>Sala</td>
                <td>Cinema</td>
                <td>Horário</td>
                <td>Data de publicação</td>
              </tr>
            </thead>

            <tbody>
              {!loading &&
                moviesList.map(item => (
                  <tr key={item.id}>
                    <td className={classes.titleContainer}>
                      <div>{item.room}</div>
                      <div>
                        {props.location.state !== undefined ? (
                          <Link
                            to={{
                              pathname: '/movieSessionForm',
                              state: { message: item, movieToEdit: props.location.state.message }
                            }}
                          >
                            Editar
                          </Link>
                        ) : (
                          <Link
                            to={{
                              pathname: '/movieSessionForm',
                              state: { message: item }
                            }}
                          >
                            Editar
                          </Link>
                        )}

                        {' | '}
                        <a onClick={() => getItemList(item)}>Excluir</a>
                      </div>
                    </td>
                    <td>{item.PartnerUnits[0].fantasyName}</td>
                    <td>{moment(item.date).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{moment(item.createdAt).format('L [às] LT')}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>

      <Dialog
        open={modalVisible}
        onClose={modalController}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir Sessão</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja realmente excluir a sessão {itemList?.room}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={modalController}>
            Não
          </Button>
          <Button color="primary" onClick={() => onDeleteItem(itemList.id)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '27px 45px',
    background: '#ece5fe'
  },
  title: {
    fontFamily: 'Matrice',
    fontSize: '32px',
    color: '#30287b'
  },
  addAnchor: {
    padding: '15px 18px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    textDecoration: 'none',
    textTransform: 'uppercase',
    background: '#b294ff',
    boxShadow: '4px 4px #30287b',
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none'
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  sorting: {
    height: '100%',
    fontSize: '12px',
    color: '#30287b',
    border: 'none',
    '& option:disabled': {
      display: 'none'
    }
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    // background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  rankingContainer: {
    '& div:first-child': {
      marginBottom: '17px'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer',
        color: '#30287b'
      }
    }
  }
})

export default MovieSession
